export default __webpack_public_path__ + "static/media/toxina.43d3f711.png";